module.exports = __webpack_public_path__ + "img/linkus-dy.d6928307.png";